/**
* this is the component for the Latest news in Section
*
* Created by Butterfly on 7/9/18
*/

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from '../../config'
import moment from 'moment'

// action import
import { ActionCreator } from '../../actions/'

// component import
import AppLink from '../AppLink'

// style import
import './style.scss'


class News extends Component {

    componentDidMount() {
        const { getNewsData } = this.props
        getNewsData()
    }

    renderItem(newsItem, index) {
        const {updated_at, title, desc, link} = newsItem

        return (
            <div className="news__item" key={index}>
                <div className="news__item__date">{moment(updated_at).format("DD MMM YY")}</div>
                <div className="news__item__title">
                    {
                        link ? (
                            <AppLink
                                className=""
                                route={link}
                                isExternal={true}
                                openInNewTab={true}>
                                {title}
                            </AppLink>
                        ) : (
                            <div>{title}</div>
                        )
                    }
                </div>
                <div className="news__item__desc">{desc}</div>
            </div>
        )
    }

    render() {
        return (
            <div className="news">
                <div className="news__header">
                    <div className="news__header__title">
                        <p>Latest News</p>
                    </div>
                </div>
                <div className="news__data">
                    <div className="news__data__wrapper">
                        {this.props.nData.map((item, index) => this.renderItem(item, index))}
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
News.propTypes = {
    nData: PropTypes.array,
    getNewsData: PropTypes.func
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        nData: state.newsState.nData
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getNewsData: action.getNewsData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(News)



// WEBPACK FOOTER //
// ./src/components/News/index.js